var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ContentCollectionFixed } from "contentCollection";
import { Env, Id, config, content } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { isCardFixed } from "pages/utils";
import React from "react";
import styled from "styled-components";
function isCompatible(homepage) {
    return (homepage.highlights !== null &&
        homepage.highlights.items.length > 0 &&
        Env.isClient);
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    return Option.some({
        key: data.highlights.uuid,
        View: function () { return (React.createElement(StyledContentCollectionFixed, { componentId: Id.component.contentCollection.highlights, listName: config.tracking.listNames.highlights, title: content.title.highlights, items: data.highlights.items.filter(isCardFixed), uuid: data.highlights.uuid, trackingEnabled: !data.fetchingData, playIcon: true })); },
    });
};
var StyledContentCollectionFixed = styled(ContentCollectionFixed)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 0 !important;\n"], ["\n  padding-bottom: 0 !important;\n"])));
var templateObject_1;
